import { withInstallFunction } from '@sgui-plus/utils/with-install'

import Message from './src/instance'

export const SgMessage = withInstallFunction(Message, '$message')
export default SgMessage

export * from './src/message'
